import { GraphQL, gql } from 'core';
import { isLoggedIn } from 'core/modules/auth.utils';
import queryString from 'query-string';
import { useEffect, useState } from 'react';

export const setQueryParams = (params: Record<string, any>) => {
  if (window) {
    window.history.pushState({}, '', `?${queryString.stringify(params)}`);
  }
};

export const getQueryParams = (): any => {
  if (window) {
    return queryString.parse(window.location.search);
  }
  return {};
};

export const updateQueryParams = (obj: any) => {
  const params = getQueryParams();
  const updatedParams = { ...params, ...obj };
  for (const key in updatedParams) {
    if (updatedParams[key] === undefined || obj[key] === null) {
      delete updatedParams[key];
    }
  }
  setQueryParams(updatedParams);
};

export const getTimeFormatted = (seconds: number | undefined) => {
  let unit = 'min';
  let value = (seconds ?? 0) / 60; // min
  if (value >= 60) {
    value /= 60; //hours
    unit = 'hrs';
  }
  if (unit === 'hrs' && value >= 24) {
    value /= 24; //days
    unit = 'days';
  }
  return { unit, value: value.toFixed(1) };
};

export const getUserMarketplaceDetails = () => {
  return GraphQL.query({
    query: gql`
      query {
        userMarketplaceDetail {
          id
          tier
          userType
          productType
          receiveModelUpdateNotification
        }
      }
    `,
    fetchPolicy: 'no-cache'
  });
};

export const updateNotificationToggle = (receiveModelUpdateNotification: boolean) => {
  return GraphQL.mutate({
    mutation: gql`
      mutation toggleUserModelUpdateNotification($receiveModelUpdateNotification: Boolean) {
        toggleUserModelUpdateNotification(
          receiveModelUpdateNotification: $receiveModelUpdateNotification
        ) {
          success
          receiveModelUpdateNotification
        }
      }
    `,
    variables: {
      receiveModelUpdateNotification
    },
    fetchPolicy: 'no-cache'
  });
};

export const useUserInfo = (): {
  data: { receiveModelUpdateNotification: boolean };
  refetch: () => void;
} => {
  const logged = isLoggedIn();
  const [data, setData] = useState({ receiveModelUpdateNotification: false });

  const fetchData = async () => {
    const response = await getUserMarketplaceDetails();
    setData(response.data.userMarketplaceDetail);
  };

  useEffect(() => {
    if (!logged) return;
    fetchData();
  }, [logged]);

  return { data, refetch: fetchData };
};
